import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ApplicationContext } from "../utils/contextsProviders";
import { isTokenExpired } from "../utils/auth";

const CHECK_INTERVAL_MS = 60 * 1000;

const SessionWatcher = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useContext(ApplicationContext);

  useEffect(() => {
    const checkSession = () => {
      const token = localStorage.getItem("token");
      if (token && isTokenExpired(token)) {
        localStorage.removeItem("token");
        setUser(null);
        if (location.pathname !== "/login") {
          navigate("/login");
        }
      }
    };

    checkSession();

    const intervalId = setInterval(checkSession, CHECK_INTERVAL_MS);

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        checkSession();
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      clearInterval(intervalId);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [location.pathname, navigate, setUser]);

  return null;
};

export default SessionWatcher;
